export default __webpack_public_path__ + "static/media/e-signed.dff31ddc.svg";